import React from 'react';

function Documents() {
  return (
    <div className='text-black'>
      <h2 className='text-2xl mb-4'>Documents</h2>
      <p>Documents content will be implemented here.</p>
    </div>
  );
}

export default Documents;
